/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import get from 'lodash/get';
import { ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { AjaxError } from 'rxjs/ajax';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ResourceFilter, ResourceSort, TableOptions } from '../../components/common/table/types';
import { handleErrorInterceptor } from '../../utils/AuthUtils';
import { RootState } from '../index';
import { Action, ActionCreators, TicketsResponse } from './actions';

const requestTicketsSuccess = (response: TicketsResponse, options: TableOptions): any => {
  return ActionCreators.FetchTicketsFulfilled.create(response, { options });
};

const requestTicketsEror = (error: AjaxError): any => {
  return ActionCreators.FetchTicketsRejected.create(error);
};

function getSortParams(sort: ResourceSort = {} as ResourceSort): { sortOrder: 'ASC' | 'DESC'; sortField: string } {
  return { sortOrder: sort.direction ? 'ASC' : 'DESC', sortField: sort.sortKey };
}

function getFilterParams(filters: ResourceFilter[] = []) {
  return filters.reduce((params, { key, value }) => {
    params[key] = value;
    return params;
  }, {});
}
export const fetchTicketsEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>,
  { ajaxRaw }: any,
): Observable<Action> => {
  return action$.pipe(
    ofType(ActionCreators.FetchTicketsPending.type),
    switchMap(($action: any): Observable<Action> => {
      const options = {
        ...state$.value.tickets.options,
      } as TableOptions;
      const params = Object.entries({
        pageNumber: get(options, 'page', 0),
        pageSize: get(options, 'limit', 0),
        ...getSortParams(get(options, 'sort', {} as ResourceSort)),
        ...getFilterParams(get(options, 'filters', [])),
        ...get(options, 'query', {}),
      }).reduce((acc, [key, value]) => {
        acc[key] = String(value);
        return acc;
      }, {} as Record<string, string>);

      return ajaxRaw.get(`/tickets?${new URLSearchParams(params).toString()}`).pipe(
        map((response: TicketsResponse): Action => requestTicketsSuccess(response, options)),
        catchError(
          (error: AjaxError): Observable<Action> => handleErrorInterceptor(error, of(requestTicketsEror(error))),
        ),
      );
    }),
  );
};
